/**
 * contries items fr
 */
export const COUNTRIES_FR: Country[] = [
    {
        name: 'France',
        code: 'fr'
    },
    {
        name: 'Espagne',
        code: 'es'
    },
    {
        name: 'Austria',
        code: 'at'
    },
    {
        name: 'Belgique',
        code: 'be'
    },
    {
        name: 'Croatie',
        code: 'hr'
    },
    {
        name: 'Czech Republic',
        code: 'cz'
    },
    {
        name: 'Danemark',
        code: 'dk'
    },
    {
        name: 'Finlande',
        code: 'fi'
    },
    {
        name: 'Allemagne',
        code: 'de'
    },
    {
        name: 'Grèce',
        code: 'gr'
    },
    {
        name: 'Hongrie',
        code: 'hu'
    },
    {
        name: 'Islande',
        code: 'is'
    },
    {
        name: 'Irlande',
        code: 'ie'
    },
    {
        name: 'Italie',
        code: 'it'
    },
    {
        name: 'Pays-Bas',
        code: 'nl'
    },
    {
        name: 'Norvège',
        code: 'no'
    },
    {
        name: 'Pologne',
        code: 'pl'
    },
    {
        name: 'Portugal',
        code: 'pt'
    },
    {
        name: 'Russie',
        code: 'ru'
    },
    {
        name: 'Serbie',
        code: 'rs'
    },
    {
        name: 'Slovaquie',
        code: 'sk'
    },
    {
        name: 'Slovénie',
        code: 'si'
    },
    {
        name: 'Suède',
        code: 'se'
    },
    {
        name: 'Suisse',
        code: 'ch'
    },
    {
        name: 'Ukraine',
        code: 'ua'
    },
    {
        name: 'United Kingdom',
        code: 'gb'
    }
];

/**
 * contries items en
 */
export const COUNTRIES_EN: Country[] = [
    {
        name: 'France',
        code: 'fr'
    },
    {
        name: 'Spain',
        code: 'es'
    },
    {
        name: 'Austria',
        code: 'at'
    },
    {
        name: 'Belgium',
        code: 'be'
    },
    {
        name: 'Croatia',
        code: 'hr'
    },
    {
        name: 'Czech Republic',
        code: 'cz'
    },
    {
        name: 'Denmark',
        code: 'dk'
    },
    {
        name: 'Finland',
        code: 'fi'
    },
    {
        name: 'Germany',
        code: 'de'
    },
    {
        name: 'Greece',
        code: 'gr'
    },
    {
        name: 'Hungary',
        code: 'hu'
    },
    {
        name: 'Iceland',
        code: 'is'
    },
    {
        name: 'Ireland',
        code: 'ie'
    },
    {
        name: 'Italy',
        code: 'it'
    },
    {
        name: 'Netherlands',
        code: 'nl'
    },
    {
        name: 'Norway',
        code: 'no'
    },
    {
        name: 'Poland',
        code: 'pl'
    },
    {
        name: 'Portugal',
        code: 'pt'
    },
    {
        name: 'Russia',
        code: 'ru'
    },
    {
        name: 'Serbia',
        code: 'rs'
    },
    {
        name: 'Slovakia',
        code: 'sk'
    },
    {
        name: 'Slovenia',
        code: 'si'
    },
    {
        name: 'Sweden',
        code: 'se'
    },
    {
        name: 'Switzerland',
        code: 'ch'
    },
    {
        name: 'Ukraine',
        code: 'ua'
    },
    {
        name: 'United Kingdom',
        code: 'gb'
    }
];

/**
 * contries items Deutsche
 */
export const COUNTRIES_DE: Country[] = [
    {
        name: 'Frankreich',
        code: 'fr'
    },
    {
        name: 'Spanien',
        code: 'es'
    },
    {
        name: 'Österreich',
        code: 'at'
    },
    {
        name: 'Belgien',
        code: 'be'
    },
    {
        name: 'Kroatien',
        code: 'hr'
    },
    {
        name: 'Tschechien',
        code: 'cz'
    },
    {
        name: 'Dänemark',
        code: 'dk'
    },
    {
        name: 'Finnland',
        code: 'fi'
    },
    {
        name: 'Allemagne',
        code: 'de'
    },
    {
        name: 'Griechenland',
        code: 'gr'
    },
    {
        name: 'Hongrie',
        code: 'hu'
    },
    {
        name: 'Insel',
        code: 'is'
    },
    {
        name: 'Irlande',
        code: 'ie'
    },
    {
        name: 'Italie',
        code: 'it'
    },
    {
        name: 'Pays-Bas',
        code: 'nl'
    },
    {
        name: 'Norvège',
        code: 'no'
    },
    {
        name: 'Pologne',
        code: 'pl'
    },
    {
        name: 'Portugal',
        code: 'pt'
    },
    {
        name: 'Russie',
        code: 'ru'
    },
    {
        name: 'Serbie',
        code: 'rs'
    },
    {
        name: 'Eslovaquia',
        code: 'sk'
    },
    {
        name: 'Slowenien',
        code: 'si'
    },
    {
        name: 'Schweden',
        code: 'se'
    },
    {
        name: 'schweizerisch',
        code: 'ch'
    },
    {
        name: 'Ukraine',
        code: 'ua'
    },
    {
        name: 'Großbritannien',
        code: 'gb'
    }
];

/**
 * contries items Espagnol
 */
export const COUNTRIES_ES: Country[] = [
    {
        name: 'Francia',
        code: 'fr'
    },
    {
        name: 'España',
        code: 'es'
    },
    {
        name: 'Austria',
        code: 'at'
    },
    {
        name: 'Bélgica',
        code: 'be'
    },
    {
        name: 'Croacia',
        code: 'hr'
    },
    {
        name: 'Republica checa',
        code: 'cz'
    },
    {
        name: 'Dinamarca',
        code: 'dk'
    },
    {
        name: 'Finlandia',
        code: 'fi'
    },
    {
        name: 'Alemania',
        code: 'de'
    },
    {
        name: 'Grecia',
        code: 'gr'
    },
    {
        name: 'Hungría',
        code: 'hu'
    },
    {
        name: 'isla',
        code: 'is'
    },
    {
        name: 'Irlanda',
        code: 'ie'
    },
    {
        name: 'Italia',
        code: 'it'
    },
    {
        name: 'Países Bajos',
        code: 'nl'
    },
    {
        name: 'Noruega',
        code: 'no'
    },
    {
        name: 'Polonia',
        code: 'pl'
    },
    {
        name: 'Portugal',
        code: 'pt'
    },
    {
        name: 'Rusia',
        code: 'ru'
    },
    {
        name: 'Serbia',
        code: 'rs'
    },
    {
        name: 'Eslovaquia',
        code: 'sk'
    },
    {
        name: 'Eslovenia',
        code: 'si'
    },
    {
        name: 'Suecia',
        code: 'se'
    },
    {
        name: 'suizo',
        code: 'ch'
    },
    {
        name: 'Ucrania',
        code: 'ua'
    },
    {
        name: 'Gran Bretaña',
        code: 'gb'
    }
];
export interface Country {
    name: string;
    code: string;
}
